import { TextField, TextFieldProps } from "@mui/material";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";

export type FormTextValue = string;

export type FormTextProps<TFormValues extends FieldValues> = Omit<TextFieldProps, "name" | "defaultValue"> & {
  name: Path<TFormValues>;
  inputType?: string;
};

export function FormText<TFormValues extends FieldValues>({
  name,
  inputType = "text",
  ...rest
}: FormTextProps<TFormValues>) {
  const { control } = useFormContext<TFormValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => <TextField {...field} {...rest} type={inputType} autoComplete="off" />}
    />
  );
}
